import React from 'react'
import styled from 'styled-components'




const LinkContainer = styled.div`
text-align:center;
padding:10px;
background-image:linear-gradient(#000080,#000080,#ffffff,#ffffff,#ffffff,#000080,#000080);
`;

const Link = styled.a`
text-align:center;
color:#000080;
font-weight:bolder;

:hover{
  text-decoration:none;
  cursor: pointer;
}
`;

function CallUs(){
    return(
        <LinkContainer>
                    <Link href="tel:08093167861"><span>call us -</span> 08093167861</Link>
       
        </LinkContainer>
    )
}

export default CallUs